import { RootState } from 'src/store/rootStore';
export const selectRequestStatus = (state: RootState) => state.status.requestStatus;